import axios from 'axios';
import { all, call, takeLatest } from 'redux-saga/effects';

import { SagaPayload } from '../../api.types';
import { SendPushNotificationRequest } from './push-notification.types';

import { requestSendPushNotification } from './push-notification.actions';

import { getSendPushNotificationRequest } from './push-notification.endpoints';

export function* performSendPushNotificationRequest({ payload }: SagaPayload<SendPushNotificationRequest>) {
  const { requestData } = payload;

  try {
    const [endpoint, options] = getSendPushNotificationRequest(requestData);

    yield call(axios, endpoint, options);
  } catch (_error) {
    // ignoring error if push notification cannot be sent
  }
}

export function* watchForSendPushNotificationRequest() {
  yield takeLatest(requestSendPushNotification.type, performSendPushNotificationRequest);
}

export default function* pushNotificationSaga() {
  yield all([watchForSendPushNotificationRequest()]);
}
